import { useMemo } from 'react';
import { pick, prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const usePostCodeConfig = () => {
    const lang = useUserSelector(prop('lang'));
    const {
        allowedCountries,
        defaultLocale,
        isPostcodeEnabled,
        postcodeConfiguration,
        postcodeProvider
    } = useAppSelector(pick([
        'allowedCountries',
        'defaultLocale',
        'isPostcodeEnabled',
        'postcodeConfiguration',
        'postcodeProvider'
    ]));

    const countries = allowedCountries.map(country => country.code.toLowerCase());
    const language = (lang || defaultLocale).slice(0, 2);

    // todo postcodeProvider 'UK' is deprecated and will be changed to 'GENERAL'
    const isEnabled = isPostcodeEnabled && (postcodeProvider === 'GENERAL' || postcodeProvider === 'UK');
    const key = 'key' in postcodeConfiguration ? postcodeConfiguration?.key : '';
    const searchUrl = 'url' in postcodeConfiguration ? postcodeConfiguration?.url : '';
    // todo postcodeConfiguration property 'userName' will be renamed later
    const retrieveUrl = 'userName' in postcodeConfiguration ? postcodeConfiguration?.userName : '';

    return useMemo(() => ({
        countries,
        isEnabled,
        key,
        language,
        retrieveUrl,
        searchUrl
    }), [
        countries,
        isEnabled,
        key,
        language,
        retrieveUrl,
        searchUrl
    ]);
};
